/* eslint-disable import/prefer-default-export */
import { css } from 'styled-components';

export const headers = css`
  h1, h2, h3, h4, h5, h6 {
    margin: 16px auto;
  }
`;
